<template>
  <header>
    <b-navbar class="app-header" fixed="top" toggleable="md" type="dark">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand :to="'/' + (isExternalUser ? 'external' : '')">
        <img :src="logoUrl" class="mw-100 mh-100 align-top nav-brand-image" />
      </b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav v-if="!isExternalUser">
          <b-nav-item to="/cx" v-if="hasDashboard() && isCXReporting">
            <span class="nav-large">
              <font-awesome-icon :icon="['far', 'circle-notch']" />
              {{ $t("Webportal.CXReporting") }}
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="$t('Webportal.CXReporting')"
            >
              <font-awesome-icon :icon="['fas', 'circle-notch']" />
            </span>
          </b-nav-item>
<!--
          <b-nav-item to="/map" v-if="hasMapView()">
            <span class="nav-large">
              <font-awesome-icon :icon="['fas', 'map']" />
              Map
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              title="Map"
            >
              <font-awesome-icon :icon="['fas', 'map']" />
            </span>
          </b-nav-item> -->

          <b-nav-item to="/cockpit" v-if="hasDashboard() && isCustomDashboardAvailable">
            <span class="nav-large">
              <font-awesome-icon :icon="['fas', 'tachometer-alt']" />
              {{ $t("Webportal.Dashboard") }}
            </span>
            <span class="nav-small"
                  v-b-tooltip.hover.nofade="toolTipDelay"
                  :title="$t('Webportal.Dashboard')">
              <font-awesome-icon :icon="['fas', 'tachometer-alt']" />
            </span>
          </b-nav-item>

          <b-nav-item to="/marketreports" v-if="hasMarketReports">
            <span class="nav-large">
              <font-awesome-icon :icon="['fas', 'file-chart-pie']" />
              {{ $t("Webportal.MarketReports") }}
            </span>
            <span class="nav-small"
                  v-b-tooltip.hover.nofade="toolTipDelay"
                  :title="$t('Webportal.MarketReports')">
              <font-awesome-icon :icon="['fas', 'file-chart-pie']" />
            </span>
          </b-nav-item>


          <b-nav-item to="/comparison" v-if="hasComparision()">
            <span class="nav-large">
              <font-awesome-icon :icon="['fas', 'chart-bar']" />
              {{ $t("Webportal.DashboardBMW.FocusKPI") }}
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="$t('Webportal.DashboardBMW.FocusKPI')"
            >
              <font-awesome-icon :icon="['fas', 'chart-bar']" />
            </span>
          </b-nav-item>
          <b-nav-item
            to="/survey/checkexplorer"
            v-if="
              hasCheckExplorer() &&
              localUserProfile.Permissions.includes('CheckExplorer')
            "
          >
            <span class="nav-large">
              <font-awesome-icon :icon="['fas', 'file-check']" />
              {{ $t("Webportal.CheckExplorer") }}
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="$t('Webportal.CheckExplorer')"
            >
              <font-awesome-icon :icon="['fas', 'file-check']" />
            </span>
          </b-nav-item>
          <b-nav-item-dropdown
            v-if="localUserProfile.Permissions.includes('MediaExplorer') || localUserProfile.Permissions.includes('ClientReports')">
            <template slot="button-content">
              <span class="nav-large">
                <font-awesome-icon :icon="['fas', 'cloud-download-alt']" />
                {{ $t('Webportal.Downloads') }}
              </span>
              <span
                class="nav-small"
                v-b-tooltip.hover.nofade="toolTipDelay"
                :title="$t('Webportal.MediaExplorer')"
              >
                <font-awesome-icon :icon="['fas', 'cloud-download-alt']" />
              </span>
            </template>
            <b-dropdown-item to="/survey/mediaexplorer"
              v-if="localUserProfile.Permissions.includes('MediaExplorer')">
              <font-awesome-icon :icon="['fas', 'image']" fixed-width />
              {{ $t("Webportal.MediaExplorer") }}
            </b-dropdown-item>
            <b-dropdown-item to="/reportfileexplorer"
              v-if="localUserProfile.Permissions.includes('ClientReports')">
              <font-awesome-icon :icon="['fas', 'file-chart-line']" fixed-width />
              {{ $t("Webportal.ReportFileExplorer") }}
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item
            to="/survey/rawdata"
            v-if="localUserProfile.Permissions.includes('RawData')"
          >
            <span class="nav-large">
              <font-awesome-icon :icon="['fas', 'file-excel']" />
              {{ $t("Webportal.RawData") }}
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="$t('Webportal.RawData')"
            >
              <font-awesome-icon :icon="['fas', 'file-excel']" />
            </span>
          </b-nav-item>
          <b-nav-item
            to="/survey/frequencies"
            v-if="localUserProfile.Permissions.includes('Frequencies')"
          >
            <span class="nav-large">
              <font-awesome-icon :icon="['fas', 'dice']" />
              {{ $t("Webportal.Frequencies") }}
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="$t('Webportal.Frequencies')"
            >
              <font-awesome-icon :icon="['fas', 'dice']" />
            </span>
          </b-nav-item>
          <b-nav-item
            to="/survey/aggregatedreports"
            v-if="localUserProfile.Permissions.includes('AggregatedReports')"
          >
            <span class="nav-large">
              <font-awesome-icon :icon="['fas', 'globe-africa']" />
              {{ $t("Webportal.AggregatedReports") }}
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="$t('Webportal.AggregatedReports')"
            >
              <font-awesome-icon :icon="['fas', 'globe-africa']" />
            </span>
          </b-nav-item>
          <b-nav-item-dropdown v-if="userHasActionRevisePermission() || userHasActionImprovementPermission()">
            <template slot="button-content">
              <span class="nav-large">
                <font-awesome-icon :icon="['fas', 'edit']" />
                <span class="nav-large">{{ $t('Webportal.Actions') }}</span>
              </span>
              <span class="nav-small" v-b-tooltip.hover.nofade="toolTipDelay" :title="$t('Webportal.Actions')">
                <font-awesome-icon :icon="['fas', 'edit']" />
              </span>
            </template>
            <b-dropdown-item v-if="userHasActionRevisePermission()" to="/action/surveyrevisionexplorer">
              <font-awesome-icon :icon="['far', 'comment-exclamation']" fixed-width />
              <span class="pl-1">{{ $t('Webportal.Actions.SurveyRevisionExplorer') }}</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="userHasActionImprovementPermission()" to="/action/surveyimprovementexplorer">
              <font-awesome-icon :icon="['far', 'clipboard-check']" fixed-width />
              <span class="pl-1">{{ $t('Webportal.Actions.SurveyImprovementExplorer') }}</span>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item
            to="/tap"
            v-if="isMSMUser && isGenericReporting"
          >
            <span class="nav-large">
              <!-- <font-awesome-icon :icon="['fas', 'usd-square']" /> -->
              VW TAP
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              title="VW TAP"
            >
              <font-awesome-icon :icon="['fas', 'usd-square']" />
            </span>
          </b-nav-item>
          <externaltools />
        </b-navbar-nav>
        <b-navbar-nav v-else>
          <b-nav-item to="/external/surveyrevisions">
            <span class="nav-large">
              <font-awesome-icon :icon="['far', 'comment-exclamation']" />
              {{ $t("Webportal.Actions.SurveyRevisionExplorer") }}
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="$t('Webportal.Actions.SurveyRevisionExplorer')"
            >
              <font-awesome-icon :icon="['fas', 'comment-exclamation']" />
            </span>
          </b-nav-item>
          <b-nav-item v-if="hasSurveyImprovement()" to="/external/surveyimprovements">
            <span class="nav-large">
              <font-awesome-icon :icon="['far', 'clipboard-check']" />
              {{ $t("Webportal.Actions.SurveyImprovementExplorer") }}
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="$t('Webportal.Actions.SurveyImprovementExplorer')"
            >
              <font-awesome-icon :icon="['fas', 'clipboard-check']" />
            </span>
          </b-nav-item>
          <b-nav-item to="/external/notificationsettings">
            <span class="nav-large">
              <font-awesome-icon :icon="['far', 'mail-bulk']" />
              {{ $t("Webportal.NotificationSettings") }}
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="$t('Webportal.NotificationSettings')"
            >
              <font-awesome-icon :icon="['fas', 'mail-bulk']" />
            </span>
          </b-nav-item>
        </b-navbar-nav>


        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item
            v-if="isMSMUser"
            to="/administration"
            v-b-tooltip.hover.nofade="toolTipDelay"
          >
            <span class="nav-large">
              <font-awesome-icon :icon="['fas', 'sliders-h']" />
              {{ $t("Webportal.Administration") }}
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="$t('Webportal.Administration')"
            >
              <font-awesome-icon :icon="['fas', 'sliders-h']" />
            </span>
          </b-nav-item>
          <b-nav-item
            v-if="!isMSMUser && hasDashboard() && (isCXReporting || isMarketReportsAdmin)"
            to="/administrationnomsmuser"
            v-b-tooltip.hover.nofade="toolTipDelay"
          >
            <span class="nav-large">
              <font-awesome-icon :icon="['fas', 'sliders-h']" />
              {{ $t("Webportal.Administration") }}
            </span>
            <span
              class="nav-small"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="$t('Webportal.Administration')"
            >
              <font-awesome-icon :icon="['fas', 'sliders-h']" />
            </span>
          </b-nav-item>
          <!-- Dropdown for active language -->
          <b-nav-item-dropdown right toggle-class="navbar-highlight">
            <template slot="button-content">
              <span
                :title="
                  getLanguageName(currentLocalization, LanguageName.Normal)
                "
                v-b-tooltip.hover.nofade="toolTipDelay"
              >
                <font-awesome-icon
                  v-if="isDefaultLocalization(currentLocalization)"
                  icon="wrench"
                />
                <span
                  v-else
                  :class="[
                    'flag-icon',
                    `flag-icon-${getRegion(currentLocalization)}`,
                  ]"
                ></span>
                <span class="nav-large">{{
                  getLanguageName(currentLocalization, LanguageName.Short)
                }}</span>
              </span>
            </template>
            <b-dropdown-item
              v-for="localization in localizations"
              :key="localization[0].localizationTextId"
              href="#"
              v-on:click="changeLocalization(localization)"
            >
              <font-awesome-icon
                v-if="isDefaultLocalization(localization)"
                icon="wrench"
                size="lg"
              />
              <span
                v-else
                :class="['flag-icon', `flag-icon-${getRegion(localization)}`]"
              ></span>
              {{ getLanguageName(localization, LanguageName.Full) }}
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right toggle-class="navbar-highlight">
            <template slot="button-content">
              <span
                :title="userDisplayName"
                v-b-tooltip.hover.nofade="toolTipDelay"
              >
                <font-awesome-icon icon="user-circle" size="lg" />
                <span class="nav-large">{{ userInitials }}</span>
              </span>
            </template>
            <b-dropdown-item disabled>
              <b-button disabled variant="dark">
                <font-awesome-icon :icon="['far', 'user']" />
                <span class="pl-1">{{ userDisplayName }}</span>
              </b-button>
            </b-dropdown-item>
            <b-dropdown-divider v-if="!isExternalUser"></b-dropdown-divider>
            <b-dropdown-item to="/user/profile" v-if="!isExternalUser">
              <font-awesome-icon :icon="['far', 'user-cog']" fixed-width />
              {{ $t("Webportal.Profile") }}
            </b-dropdown-item>
            <template
              v-if="localUserProfile.Permissions.includes('NotificationSettings')">
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item to="/user/notificationsettings">
                <font-awesome-icon :icon="['far', 'mail-bulk']" fixed-width />
                {{ $t("Webportal.NotificationSettings") }}
              </b-dropdown-item>
            </template>
            <template
              v-if="localUserProfile.Permissions.includes('LocationNotification') && areLocationNotificationsVisible">
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item to="/user/locationnotifications">
                <font-awesome-icon :icon="['far', 'mail-bulk']" fixed-width />
                {{ $t("Webportal.LocationNotifications") }}
              </b-dropdown-item>
            </template>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="showGuide = !showGuide">
              <font-awesome-icon :icon="['far', 'question-circle']" fixed-width />
              <span>{{ $t('Webportal.Help') }}</span>
            </b-dropdown-item>
            <b-dropdown-divider v-if="!isExternalIdentityProvider"></b-dropdown-divider>
            <b-dropdown-item v-if="!isExternalIdentityProvider" href="#" @click="logout">
              <font-awesome-icon :icon="['far', 'sign-out-alt']" fixed-width />
              {{ $t("Webportal.SignOut") }}
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <!-- Show Menu including Quickstart Video -->
          <b-nav-item-dropdown v-if="hasTargetVideo()" right toggle-class="navbar-highlight">
            <template slot="button-content">
              <span class="nav-large text-warning"
                    v-b-tooltip.hover.nofade="toolTipDelay" :title="$t('Webportal.Guideline')">
                <font-awesome-icon icon="question" class="text-warning" />
              </span>
              <span class="nav-small text-warning"
                    v-b-tooltip.hover.nofade="toolTipDelay" :title="$t('Webportal.Guideline')">
                <font-awesome-icon icon="question" class="text-warning" />
              </span>
            </template>
            <b-dropdown-item href="#" @click="handleShowVideoClick">
              <font-awesome-icon :icon="['fa', 'film']" fixed-width />
              {{ $t('Webportal.Document.QuickstartVideo') }}
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <manualdownload :isSubItem="true" />
            
            <b-dropdown-divider v-if="hasStaticDocument('kpi-explanation')"></b-dropdown-divider>
            
            <b-dropdown-item v-if="hasStaticDocument('kpi-explanation')" @click="downloadDocument('kpi-explanation')">
              <b-icon icon="file-earmark-text" />
              {{ $t('Webportal.Document.KpiExplanation') }}
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <!-- Show Manual Button, no Video -->
          <manualdownload v-else />

        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <guide v-if="showGuide" />
    
    <b-modal ref="modal-3" size="xl" style="padding: 4rem; margin:4rem;" >
      <div class="position-relative thegrid">
        <div />
        <video width="100%" controls  autoplay>
          <source :src="getVidUrl()" type="video/mp4">
          Your browser does not support HTML video.
        </video>
        <div />
      </div>
      <template #modal-footer="{  }">
        <div style="display: none;" />
      </template>
      <template #modal-title>
        <div> 
          <span style="font-size: 1.0em; line-height: 1.0em;">{{ $t('Webportal.Document.QuickstartVideo') }}</span>
        </div>
      </template>
    </b-modal>

  </header>
</template>


<script>
import { i18n, changeLocalization } from "@/i18n";

import LocalizationsService from "@/services/LocalizationsService";
import DashboardService from "@/services/DashboardService-APP_TARGET";
import DownloadFileMixin from '@/mixins/DownloadFileMixin'
import SurveyRevisionMixin from "@/mixins/SurveyRevisionMixin";
import SurveyImprovementMixin from "@/mixins/SurveyImprovementMixin";
import AuthenticationService from "@/services/AuthenticationService";
import UsersService from "@/services/UsersService";
import EventBus from "@/services/EventBus.js";
import AppConfig from "@/mixins/AppConfig-APP_TARGET";
import externaltools from "./ExternalTools-APP_TARGET";
import manualdownload from "./ManualDownload-APP_TARGET";
import guide from "./Guide";

export const LanguageName = {
  Full: 1,
  Normal: 2,
  Short: 3,
};

export default {
  name: "AppHeader",

  mixins: [ AppConfig, DownloadFileMixin, SurveyRevisionMixin, SurveyImprovementMixin ],

  components: {
    externaltools,
    manualdownload,
    guide,
  },

  data() {
    return {
      localizations: {},
      manualLink: "#",
      currentLocalization: null,
      LanguageName: LanguageName,
      logoUrl:
        this.getCustomLogoUrl() || AuthenticationService.logoExternalImageUrl,
      showGuide: false,
    };
  },

  mounted() {
    LocalizationsService.getLocalizationTexts().then((response) => {
      this.localizations = _(response.data)
        .filter(
          (element) =>
            element.localizationTextId !== "deflt" ||
            AuthenticationService.isMSMUser
        )
        .groupBy("localizationTextId")
        .forEach((element) => {
          element.sort((a, b) => {
            if (a.localizationId === "en-GB") return 1;
            else if (b.localizationId === "en-GB") return -1;
            else return 0;
          });
        });

      this.currentLocalization = this.localizations[i18n.locale];
    });

    EventBus.$on("LocalizationChanged", (localizationId) => {
      this.currentLocalization = this.localizations[localizationId];
    });

    EventBus.$on("GuideClosed", () => {
      this.showGuide = false;
    });
  },

  methods: {
    hasClass(element) {
      return element.classList;
    },

    getLanguageName(localization, languageName = LanguageName.Full) {
      if (!localization) return "";

      if (languageName === LanguageName.Full)
        if (localization.length > 1)
          return `${localization[0].languageName} - ${localization[1].languageName}`;
        else return localization[0].languageName;
      else if (languageName === LanguageName.Normal)
        return localization[0].languageName;
      else return localization[0].languageNameShort;
    },

    getRegion(localization) {
      if (!localization || !localization[0].localizationTextId.includes("-"))
        return "";
      else
        return localization[0].localizationTextId.split("-")[1].toLowerCase();
    },

    isDefaultLocalization(localization) {
      return localization && localization[0].localizationTextId === "deflt";
    },

    changeLocalization(localization) {
      changeLocalization(localization[0].localizationTextId, AuthenticationService.localUserProfile.ClientId);
      UsersService.setUserProfile({
        LocalizationId: localization[0].localizationTextId,
      });
    },

    logout() {
      AuthenticationService.logout();
      if (this.isExternalUser)
        this.$router.push({ name: 'signedout' })
    },

    handleShowVideoClick(event) {
      this.$refs['modal-3'].toggle();
    },
    getVidUrl() {
      return `${process.env.BASE_URL}fixedmedia/bmw-quickstart-video.mp4`;
    },
    hasTargetVideo() {
      return APP_TARGET === "bmw";
    },

    downloadDocument() {
      DashboardService.getStaticDocument(null, window.location.hostname, 'kpi-explanation')
        .then(response => {
          this.downloadFile(response);
        });
    },
  },

  computed: {
    isCXReporting() {
      return AuthenticationService.localUserProfile.Permissions.includes(
        "360Reporting" // TODO: rename to CXReporting in database?
      );
    },
    isMarketReportsAdmin() {
      return AuthenticationService.localUserProfile.Permissions.includes(
        "Market Reports Admin"
      );
    },

    isCustomDashboardAvailable() {
      if (APP_TARGET === "porschesar")
        return AuthenticationService.localUserProfile.Permissions.includes('CustomDashboard');
      else
        return true;
    },

    isMSMUser: function () {
      return AuthenticationService.isMSMUser;
    },

    isExternalUser: function() {
      return AuthenticationService.isExternalUser;
    },

    isExternalIdentityProvider: function () {
      return AuthenticationService.isExternalIdentityProvider;
    },

    localUserProfile: function () {
      return AuthenticationService.localUserProfile;
    },

    userDisplayName: function() {
      return `${this.localUserProfile.FirstName} ${this.localUserProfile.LastName}`;
    },

    userInitials: function() {
      return this.getUserInitials(
        this.localUserProfile.FirstName,
        this.localUserProfile.LastName
      );
    },

    isGenericReporting() {
      return (APP_TARGET === "" || APP_TARGET === "training");
    },

    areLocationNotificationsVisible: function() {
      return APP_TARGET === 'db';
    }
  },
};
</script>


<style lang="scss" scoped>
.thegrid {
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: 1fr 75% 1fr;
}

</style>